import Input from 'components/Input';
import Select from 'components/Select';
import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";


function AddDepartmentModal({
    open,
    onClose
}) {

    return (
        <Modal className='add-workplace-modal' show={open} onHide={onClose} centered>
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h4 classNam="sub-title mb-0">Add Department</h4>
                <button
                    type="button"
                    className="close bg-transparent border-0"
                    onClick={onClose}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <Modal.Body className='pt-0'>
                <form>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <label>Workplace Name</label>
                            {/* <input type='text' className='input-search w-100' placeholder='Enter Name'/> */}
                            <Input
                                fullWidth
                                variant='flat'
                                placeholder='Enter Name'
                            />
                        </div>
                        <div className='col-12 mt-3'>
                            <label>Workplace Information</label>
                            <Select
                                fullWidth
                                placeholder='Workplace Information'
                                options={[]}
                            />
                        </div>
                        <div className='col-12 mt-4'>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="home-tab" data-bs-toggle="tab"
                                        data-bs-target="#home" type="button" role="tab" aria-controls="home"
                                        aria-selected="true">Employee (0)
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="profile-tab" data-bs-toggle="tab"
                                        data-bs-target="#profile" type="button" role="tab"
                                        aria-controls="profile" aria-selected="false">Contractors (0)
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <div className="row">
                                        <div className='col-12 mt-3'>
                                            <label>Workplace Information</label>
                                            <Select
                                                fullWidth
                                                placeholder='Workplace Information'
                                                options={[]}
                                            />
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label>Name*</label>
                                            <Input
                                                fullWidth
                                                variant='flat'
                                                placeholder='Enter Name'
                                            />
                                        </div>
                                        <div className='col-lg-6 mt-3'>
                                            <label>Email</label>
                                            <Input
                                                fullWidth
                                                variant='flat'
                                                placeholder='Enter email'
                                                type='emal'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel"
                                    aria-labelledby="profile-tab">...
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-start mb-5'>
                <Button className='button-orange'>
                    Add Deportment
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default AddDepartmentModal;
